import {IBandwidthState} from "../reducers/bandwidth.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {BandwidthData} from "../../websites/website/booster/mappers/cloudflare/bandwidth";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getBandwidthState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.bandwidth);

export const getBandwidth = (websiteId: number) => createSelector(getBandwidthState,
  state => ((state[websiteId] && state[websiteId].bandwidthData) || {} as BandwidthData)
);


export const getBandwidthLoading = (websiteId: number) => createSelector(getBandwidthState,
  (state: IBandwidthState) =>
    state[websiteId].loading
);

export const getBandwidthLoaded = (websiteId: number) => createSelector(getBandwidthState,
  (state: IBandwidthState) =>
    state[websiteId] ? state[websiteId].loaded : false
);
